import DonationSuccess from "./DonationSuccess";

export default DonationSuccess;